export const AUTH_TOKEN = "auth_token_cifsj";
export const REFRESH_TOKEN = "refresh_token_cifsj";
export const AUTH_STORAGE = "auth-storage-cifsj";
export const USER_ID = "user_id_cifsj";
export const USER = "user_cifsj";
export const ROLE = "role_cifsj";
export const USER_LOGGED = "user_logged_cifsj";
